var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "meta-item",
    {
      attrs: { icon: "globe" },
      scopedSlots: _vm._u([
        {
          key: "key",
          fn: function () {
            return [_vm._v("Due By:")]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(
        "\n  " +
          _vm._s(
            _vm._f("nullable")(
              _vm._f("date")(
                _vm.booking.complete_by_date,
                _vm.$user.date_format_preference
              )
            )
          ) +
          "\n"
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }